import { ButtonIcon, ButtonWrapper } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { commonInputHeight } from "@solveindustrial/Utilities/styleguide/FormFields/formField";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const pagination: RecursivePartial<{
    defaultProps?: PaginationPresentationProps | undefined;
}> = {
    defaultProps: {
        mergeCss: true,
        cssOverrides: {
            currentButton: css`
                height: 32px;
                width: 32px;
                padding: 4px;
                line-height: normal;

                ${mediaQueriesBP.minMD} {
                    min-height: 32px;
                    height: 32px;
                    width: 32px;
                    padding: 4px;
                    line-height: normal;
                }
            `,
            linkList: css`
                ul {
                    display: flex;
                    align-items: center;
                }

                ${ButtonWrapper} {
                    height: 32px;
                    width: 32px;
                    padding: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    ${IconWrapper} {
                        height: auto;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        > svg {
                            height: 25px;
                            width: 25px;
                        }
                    }

                    &:not([aria-current="page"]) {
                        &:not(:disabled) {
                            color: ${getColor(colorStrings.primaryMain)};
                            background-color: transparent;
                            ${ButtonIcon} {
                                color: ${getColor(colorStrings.primaryMain)};
                            }
                            &:hover {
                                color: ${getColor(colorStrings.commonGlobalWhite)};
                                background-color: ${getColor(colorStrings.commonPrimarySecond)};

                                ${ButtonIcon} {
                                    color: ${getColor(colorStrings.commonGlobalWhite)};
                                }
                                &[aria-label="Next page"],
                                &[aria-label="Previous page"],
                                &[aria-label="First page"],
                                &[aria-label="Last page"] {
                                    color: ${getColor(colorStrings.commonPrimarySecond)};
                                    background-color: transparent;
                                    ${ButtonIcon} {
                                        color: ${getColor(colorStrings.commonPrimarySecond)};
                                    }
                                }
                            }
                        }
                    }
                }
            `,
        },
        selectProps: {
            cssOverrides: {
                formField: css`
                    justify-content: center;
                    align-items: center;

                    label {
                        font-size: 16px;
                        line-height: 30px;
                        padding: 0 8px 0 0;
                    }
                `,
                inputSelect: css`
                    ${commonInputHeight}
                    border-radius: 4px;

                    & + ${IconWrapper} {
                        height: 100%;
                        width: auto;
                    }

                    ${mediaQueriesBP.minMD} {
                        min-height: 30px;
                        height: 30px;
                    }
                `,
            },
        },
    },
};
